import { orchestrator } from 'satcheljs';
import { clickAgendaEvent, doubleClickAgendaEvent, rightClickAgendaEvent } from 'owa-calendar-list';
import { pushNewView, updateSelectedCalendarEvent } from '../actions/timePanelStoreActions';
import { AgendaScenarioId } from '../constants';

export const clickAgendaOrchestrator = orchestrator(clickAgendaEvent, actionMessage => {
    const { id, scenarioId } = actionMessage;
    if (scenarioId === AgendaScenarioId) {
        updateSelectedCalendarEvent(id);
        pushNewView('EventDetails');
    }
});

export const doubleClickAgendaOrchestrator = orchestrator(doubleClickAgendaEvent, actionMessage => {
    const { id, scenarioId } = actionMessage;
    if (scenarioId === AgendaScenarioId) {
        updateSelectedCalendarEvent(id);
        pushNewView('EventDetails');
    }
});

export const rightClickAgendaOrchestrator = orchestrator(rightClickAgendaEvent, actionMessage => {
    // TODO VSO 43771 adding contextual menu
});
